import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Select,
  Input,
  Button,
  Tooltip,
  Modal,
  message,
  Tag,
} from "antd";
import {
  API_BASE,
  //  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_space_management_admin,
  req_delete_usm_space,
  req_downloadfile_usm_space_management_admin,
  req_list_usm_course_roomcode,
  req_list_usm_storage_goods,
  req_list_usm_all_course_roomcode,
} from "../../api";

import SpaceManagementModalAdd from "./space-management-modal-add";
import SpaceManagementModalEdit from "./space-management-modal-edit";
import SpaceCourseRoomModal from "./space-course-room-modal";
import SpaceStorageGoodsModal from "./space-storage-goods-modal";
import SpaceRoomCourseListModal from "./space-room-course-list-modal";
class SpaceManagement extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    courseRooms: [],
    storageGoods: [],
    roomCourses: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: 100,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    buildingName: "NONE",
    departmentCode: "NONE",

    isShowConfigModal: false,
    isShowAddModal: false,
    isShowEditModal: false,
    isShowCourseModal: false,
    isShowStorageModal: false,
    isShowCoursesModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      buildingName,
      departmentCode,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_management_admin(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      buildingName,
      departmentCode,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_list_course_rooms = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_course_roomcode(key, token);
    // console.log(result);
    if (result.total > 0) {
      const courseRooms = result.data;
      this.setState({ courseRooms, isShowCourseModal: true });
      //console.log(this.state);
    } else {
      const courseRooms = [];
      this.setState({ courseRooms });
    }
  };

  api_list_storage_goods = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_storage_goods(key, token);
    // console.log(result);
    if (result.total > 0) {
      const storageGoods = result.data;
      this.setState({ storageGoods, isShowStorageModal: true });
      //console.log(this.state);
    } else {
      const storageGoods = [];
      this.setState({ storageGoods });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      buildingName,
      departmentCode,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_management_admin(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      buildingName,
      departmentCode,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_delete_item = async (key) => {
    const { token, userCode } = this.props.user;
    const result = await req_delete_usm_space(key, userCode, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_list_room_courses = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_all_course_roomcode(key, token);
    // console.log(result);
    if (result.total > 0) {
      const roomCourses = result.data;
      this.setState({ roomCourses, isShowCoursesModal: true });
      //console.log(this.state);
    } else {
      const roomCourses = [];
      this.setState({ roomCourses });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "SpaceCode",
        width: 24,
        fixed: "left",
      },
      {
        title: "空間名稱",
        width: 40,
        fixed: "left",
        render: (item) => {
          const { SpaceStandardTwName, SpaceStandardEnName } = item;
          return (
            <>
              {SpaceStandardTwName}
              <br />
              {SpaceStandardEnName}
            </>
          );
        },
      },
      {
        title: "所在建物",
        width: 28,
        render: (item) => {
          const { BuildingName, Floor } = item;
          return (
            <>
              {BuildingName}
              <br />
              {Floor}樓
            </>
          );
        },
      },
      {
        title: "面(容)積",
        width: 25,
        render: (item) => {
          const { TwPingSize, SquareMeter, Accommodate } = item;
          return (
            <>
              {TwPingSize}坪 / {Accommodate}人
              <br />
              {SquareMeter}公尺
            </>
          );
        },
      },
      {
        title: "用途別",
        width: 30,
        render: (item) => {
          const { UseType, TvedbUseType } = item;
          return (
            <>
              自訂：{UseType}
              <br />
              校資：{TvedbUseType}
            </>
          );
        },
      },
      {
        title: "保管單位",
        width: 28,
        render: (item) => {
          const { ShortDepartmentTwName, CustodianTwName } = item;
          return (
            <>
              {ShortDepartmentTwName}
              <br />
              {CustodianTwName}
            </>
          );
        },
      },
      {
        title: "排課狀況",
        width: 40,
        render: (item) => {
          const {
            YearSemester,
            SemesterWeekClassTotal,
            ALessonTotal,
            BLessonTotal,
            CLessonTotal,
          } = item;
          return (
            <>
              <button
                className={
                  SemesterWeekClassTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                disabled={SemesterWeekClassTotal === 0 ? "true" : ""}
                onClick={() => this.handle_show_ui_modal("COURSELIST", item)}
              >
                學年期：{YearSemester} 總：{SemesterWeekClassTotal}
              </button>
              <br />
              <Tag color={ALessonTotal > 0 ? "orange" : ""}>
                日：{ALessonTotal}
              </Tag>
              <Tag color={BLessonTotal > 0 ? "blue" : ""}>
                進：{BLessonTotal}
              </Tag>
              <Tag color={CLessonTotal > 0 ? "green" : ""}>
                它：{CLessonTotal}
              </Tag>
            </>
          );
        },
      },
      {
        title: "",
        width: 50,
        fixed: "right",
        render: (item) => {
          const { userLevel } = this.state;
          const { CourseSpaceTotal, StorageGoodsTotal } = item;
          return (
            <>
              <button
                className={
                  CourseSpaceTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                style={{ width: "90px" }}
                onClick={() =>
                  this.handle_show_ui_modal("COURSEROOMSLIST", item)
                }
                disabled={CourseSpaceTotal > 0 ? false : true}
              >
                <i className="fa fa-book"></i> 課務({CourseSpaceTotal})
              </button>

              {userLevel === "PERSIONAL" ? (
                ""
              ) : (
                <button
                  className="btn btn-outline-dark btn-sm"
                  style={{ width: "82px" }}
                  onClick={() => this.handle_show_ui_modal("EDIT", item)}
                >
                  <i className="fa fa-cog"></i> 修改
                </button>
              )}

              <button
                className={
                  StorageGoodsTotal > 0
                    ? "btn btn-outline-danger btn-sm"
                    : "btn btn-outline-secondary btn-sm"
                }
                style={{ width: "90px" }}
                onClick={() =>
                  this.handle_show_ui_modal("STORAGEGOODSLIST", item)
                }
                disabled={StorageGoodsTotal > 0 ? false : true}
              >
                <i className="fa fa-shopping-cart"></i> 會總({StorageGoodsTotal}
                )
              </button>
              {userLevel === "WORKMANAGER" ? (
                <button
                  className="btn btn-outline-dark btn-sm"
                  style={{ width: "82px" }}
                  onClick={() => this.handle_show_ui_modal("DELETE", item)}
                  // disabled={CourseSpaceTotal > 0 ? true : false}
                >
                  <i className="fa fa-times"></i> 刪除
                </button>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    const { SpaceCode } = item;
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      case "EDIT":
        this.setState({ isShowEditModal: true, item });
        break;
      case "DELETE":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定刪除此空間資訊`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "CONFIG":
        this.setState({ isShowConfigModal: true });
        break;
      case "COURSEROOMSLIST":
        this.api_list_course_rooms(SpaceCode);
        break;
      case "STORAGEGOODSLIST":
        this.api_list_storage_goods(SpaceCode);
        break;
      case "COURSELIST":
        this.api_list_room_courses(SpaceCode);
        break;
      default:
    }
    this.setState({ item: item });
  };

  handleSelectedChange(value, field) {
    if (field === "BuildingName") {
      this.setState({ buildingName: value });
    }
  }

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isShowConfigModal,
      isShowAddModal,
      isShowEditModal,
      isShowCourseModal,
      isShowStorageModal,
      isShowCoursesModal,
      courseRooms,
      storageGoods,
      userLevel,
      buildingName,
      departmentCode,
      roomCourses,
    } = this.state;
    const title = (
      <>
        <Select
          defaultValue={buildingName}
          onChange={(value) => this.setState({ buildingName: value })}
          style={{ width: 140 }}
        >
          <Select.Option value="NONE">請選擇建物</Select.Option>
          <Select.Option value="美術系館">(A)美術系館</Select.Option>
          <Select.Option value="商學大樓">(B)商學大樓</Select.Option>
          <Select.Option value="中正大樓">(C)中正大樓</Select.Option>
          <Select.Option value="中央文創工廠">(CC)中央文創工廠</Select.Option>
          <Select.Option value="設計大樓">(D)設計大樓</Select.Option>
          <Select.Option value="教育大樓">(E)教育大樓</Select.Option>
          <Select.Option value="服設館">(F)服設館</Select.Option>
          <Select.Option value="家政館">(H)家政館</Select.Option>
          <Select.Option value="幼教大樓">(K)幼教大樓</Select.Option>
          <Select.Option value="圖書資訊大樓">(L)圖書資訊大樓</Select.Option>
          <Select.Option value="生活科技大樓">(LT)生活科技大樓</Select.Option>
          <Select.Option value="音樂館">(M)音樂館</Select.Option>
          <Select.Option value="多功能展演中心">
            (MF)多功能展演中心
          </Select.Option>
          <Select.Option value="乃建堂">(N)乃建堂</Select.Option>
          <Select.Option value="學生活動中心">(S)學生活動中心</Select.Option>
          <Select.Option value="教學大樓">(T)教學大樓</Select.Option>
          <Select.Option value="育樂館">(Y)育樂館</Select.Option>
          <Select.Option value="集賢盧">集賢盧</Select.Option>
          <Select.Option value="馨如樓">馨如樓</Select.Option>
          <Select.Option value="體育室">體育室</Select.Option>
          <Select.Option value="貨櫃屋">貨櫃屋</Select.Option>
          <Select.Option value="臨時教室">臨時教室</Select.Option>
        </Select>
        <Select
          defaultValue={departmentCode}
          onChange={(value) => this.setState({ departmentCode: value })}
          style={{ width: 140 }}
        >
          <Select.Option value="NONE">選擇保管單位</Select.Option>
          <Select.Option value="AA000">教務處</Select.Option>
          <Select.Option value="AB000">學生事務處</Select.Option>
          <Select.Option value="AC000">總務處</Select.Option>
          <Select.Option value="AD000">研究發展處</Select.Option>
          <Select.Option value="AE000">進修部</Select.Option>
          <Select.Option value="AF000">通識教育中心</Select.Option>
          <Select.Option value="AG000">網路與資訊中心</Select.Option>
          <Select.Option value="AH000">圖書館</Select.Option>
          <Select.Option value="AI000">人事室</Select.Option>
          <Select.Option value="AJ000">會計室</Select.Option>
          <Select.Option value="AK000">秘書室</Select.Option>
          <Select.Option value="AM000">體育室</Select.Option>
          <Select.Option value="AA100">教學資源中心</Select.Option>
          <Select.Option value="CA000">全球刺繡研究發展中心</Select.Option>
          <Select.Option value="CB000">語文訓練中心</Select.Option>
          <Select.Option value="CC000">文化創意設計研發中心</Select.Option>
          <Select.Option value="CD000">校務研究中心</Select.Option>
          <Select.Option value="CE000">漢家幼兒園</Select.Option>
          <Select.Option value="BA000">生活科技學院</Select.Option>
          <Select.Option value="BA100">美容造型設計系</Select.Option>
          <Select.Option value="BA200">餐飲系</Select.Option>
          <Select.Option value="BA300">運動休閒與健康管理系</Select.Option>
          <Select.Option value="BA400">服飾設計管理系</Select.Option>
          <Select.Option value="BA500">幼兒保育系</Select.Option>
          <Select.Option value="BA600">生活服務產業系</Select.Option>
          <Select.Option value="BB000">管理學院</Select.Option>
          <Select.Option value="BB100">財務金融系</Select.Option>
          <Select.Option value="BB200">企業管理系</Select.Option>
          <Select.Option value="BB300">國際企業經營系</Select.Option>
          <Select.Option value="BB400">資訊管理系</Select.Option>
          <Select.Option value="BB500">
            連鎖加盟經營管理學士學位學程
          </Select.Option>
          <Select.Option value="BC000">設計學院</Select.Option>
          <Select.Option value="BC100">視覺傳達設計系</Select.Option>
          <Select.Option value="BC200">多媒體動畫系</Select.Option>
          <Select.Option value="BC300">漫畫系</Select.Option>
          <Select.Option value="BC400">室內設計系</Select.Option>
          <Select.Option value="BC500">商品設計系</Select.Option>
          <Select.Option value="BC600">時尚設計系</Select.Option>
          <Select.Option value="BD000">藝術學院</Select.Option>
          <Select.Option value="BD100">音樂系</Select.Option>
          <Select.Option value="BD200">流行音樂系</Select.Option>
          <Select.Option value="BD300">美術系</Select.Option>
          <Select.Option value="BD400">舞蹈系</Select.Option>
          <Select.Option value="BE000">旅遊學院</Select.Option>
          <Select.Option value="BE100">旅館管理系</Select.Option>
          <Select.Option value="BE200">餐旅管理學士學位學程</Select.Option>
          <Select.Option value="BE300">應用英語系</Select.Option>
          <Select.Option value="BE400">會計資訊系</Select.Option>
          <Select.Option value="BE500">養生休閒管理系</Select.Option>
          <Select.Option value="BF000">師培中心</Select.Option>
        </Select>
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="Floor">樓層</Select.Option>
          <Select.Option value="SpaceCode">空間編號</Select.Option>
          <Select.Option value="SpaceStandardTwName">
            空間中文名稱
          </Select.Option>
          <Select.Option value="CustodianTwName">保管人</Select.Option>
          <Select.Option value="UseType">用途別</Select.Option>
          <Select.Option value="TvedbUseType">校資庫分類</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        {userLevel === "WORKMANAGER" ? (
          <Button
            type="primary"
            onClick={() => this.handle_show_ui_modal("ADD", {})}
          >
            <i className="fa fa-plus" style={{ paddingRight: "4px" }}></i> 新增
          </Button>
        ) : (
          ""
        )}{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>{" "}
          匯出
        </Button>
        <p></p>
      </>
    );
    return (
      <>
        {title}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100, 200, 400, 800, 1000],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
          <Modal
            destroyOnClose={true}
            visible={isShowConfigModal}
            width={"90%"}
            onOk={() => {
              this.setState({ isShowConfigModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isShowConfigModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            {/* <EquipmentModalConfig space={item} /> */}
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowAddModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowAddModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isShowAddModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceManagementModalAdd />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowEditModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowEditModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isShowEditModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceManagementModalEdit space={item} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowCourseModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowCourseModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowCourseModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceCourseRoomModal rooms={courseRooms} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowStorageModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowStorageModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowStorageModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceStorageGoodsModal goods={storageGoods} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowCoursesModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowCoursesModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowCoursesModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceRoomCourseListModal rooms={roomCourses} />
          </Modal>
        </Card>
      </>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(SpaceManagement);
